import { createStore } from 'vuex'

import address from '@/store/modules/Address'

import dataTableButtonClick from '@/store/modules/DataTableButtonClick'

import merchants from '@/store/modules/Merchants'
import merchantDocuments from '@/store/modules/MerchantDocuments'
import merchantBillingAccount from '@/store/modules/MerchantBillingAccount'

import merchantBeneficiary from './modules/MerchantBeneficiary'

import merchantTransactionCharge from '@/store/modules/MerchantTransactionCharge'
import auditTrail from '@/store/modules/AuditTrail'

import fundDisbursement from '@/store/modules/FundDisbursement'

import merchantAppOperation from '@/store/modules/MerchantAppOperation'
import merchantAppPrivilege from '@/store/modules/MerchantAppPrivilege'
import merchantUserAppOperation from '@/store/modules/MerchantUserAppOperation'

import merchantTransactionRangeApproval from '@/store/modules/MerchantTransactionRangeApproval'
import merchantTransactionAuthorizer from '@/store/modules/MerchantTransactionAuthorizer'

import users from '@/store/modules/Users'
import userDepartment from '@/store/modules/UserDepartment.store'
import userOperationPrivilege from '@/store/modules/UserOperationPrivilege.store'

import bank from '@/store/modules/Bank.store'
import department from '@/store/modules/Department.store'
import departmentAppOperation from '@/store/modules/DepartmentOperation.store'
import appOperation from '@/store/modules/AppOperation.store'
import privilege from '@/store/modules/Privilege.store'

import transactionProcessor from './modules/TransactionProcessor'

import report from './modules/Report'

import pagination from './modules/Pagination'

import sessionInactivity from './modules/SessionInactivity'

const store = createStore({
  state: {
    loading: false,
    hasConnectionError: false,
    actionStatus: '',
    actionMessage: '',
    merchantId: ''
  },

  getters: {
    _globalLoading: (state) => state.loading,
    _hasConnectionError: (state) => state.hasConnectionError,
    _actionStatus: (state) => state.actionStatus,
    _actionMessage: (state) => state.actionMessage,
    _merchantId: (state) => state.merchantId
  },

  mutations: {
    LOADING (state, value) {
      state.loading = value
    },
    HAS_CONNECTION_ERROR (state, value) {
      state.hasConnectionError = value
    },
    ACTION_STATUS (state, value) {
      state.actionStatus = value
    },
    ACTION_MESSAGE (state, value) {
      state.actionMessage = value
    },
    SAVE_MERCHANT_ID (state, value) {
      state.merchantId = value
    }
  },

  modules: {
    address,
    dataTableButtonClick,
    merchants,
    merchantDocuments,
    merchantBillingAccount,
    merchantTransactionCharge,
    // -------------------------------------
    fundDisbursement,
    // -------------------------------------
    merchantAppOperation,
    merchantAppPrivilege,
    merchantUserAppOperation,
    // -------------------------------------
    merchantTransactionRangeApproval,
    merchantTransactionAuthorizer,
    // -------------------------------------
    merchantBeneficiary,
    // --------------------------------------
    auditTrail,
    // --------------------------------------
    users,
    userDepartment,
    userOperationPrivilege,
    // -------------------------------------
    bank,
    department,
    departmentAppOperation,
    appOperation,
    privilege,
    // -------------------------------------
    transactionProcessor,
    // -------------------------------------
    report,
    // -------------------------------------
    pagination,
    // -------------------------------------
    sessionInactivity
  }
})

export default store
